<template lang="pug">
div
  div.d-flex.justify-center.mt-16(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
  div(v-else)
    v-card.pa-6.mt-4.round-xl(outlined)
      v-row(align="center")
        v-col(cols="8")
          div
            div.text-md.font-semibold.neutral700--text Review offers
            div.text-md.neutral700--text.mt-1 Set an offer reward for your customer if they submit a review. This offers will be informed in your review requests messages
        v-col(cols="4")
          div.d-flex.justify-end.align-center
            y-button(:label="offer ? 'Edit' : 'Set up'" size="sm" outlined :loading="isLoading" @click="showOfferDeliveranceDialog = true")
            div.ml-3(v-if="offer")
              y-switch.mb-n3(v-model="offerEnabled" @change="statusChanged(offerEnabled)")
      
      template(v-if="offerEnabled")
        div.text-md.font-semibold.neutral700--text.mt-6 Applies to
        ul.mt-5(v-if="offer.hasOwnProperty('upon_any_purchase')")
          li.text-md.neutral700--text.ml-2(v-if="offer.upon_any_purchase") All inventory & services
          li.text-md.neutral700--text.ml-2(v-else) Specific inventory and services ({{ offer.purchase_products.length }})
        template(v-if="offer.hasOwnProperty('upon_any_purchase') && !offer.upon_any_purchase")
          inventory-services-selection(v-model="offer.purchase_products" readonly)

        div.text-md.font-semibold.neutral700--text.mt-6 Offers reward
        ul.mt-5(v-if="offer.reward_type")
          li.text-md.neutral700--text.ml-2(v-if="offer.reward_type === 'discount_percentage'") {{ offer.discount_percentage }}% percentage discount
          li.text-md.neutral700--text.ml-2(v-if="offer.reward_type === 'discount_amount'") Discount {{ offer.discount_amount | displayPrice($currency) }}
          li.text-md.neutral700--text.ml-2(v-if="offer.reward_type === 'free_item' && offer.free_item_type === 'visit'") Free visit
          li.text-md.neutral700--text.ml-2(v-if="offer.reward_type === 'free_item' && offer.free_item_type === 'other'") Free item: {{ offer.free_item_name }}
          li.text-md.neutral700--text.ml-2(v-if="offer.reward_type === 'free_item' && offer.free_item_type === 'product'") Free:
        template(v-if="offer.reward_type === 'free_item' && offer.free_item_type === 'product'")
          inventory-services-selection(v-model="offer.free_products" readonly)

        //- SMS
        div.text-md.font-semibold.neutral700--text.mt-6 Deliverance
        v-card.round-xl.content-box.pa-6.mt-3(outlined)
          v-row(align="center")
            v-col(cols="2")
              div.d-flex.align-center
                v-icon.mr-3(size="20" color="neutral500") $yzi-message-square-02
                div.text-md.font-semibold.neutral700--text SMS
            v-col
              div
                div.text-xs.font-semibold.neutral700--text Offer will be sent:
                div.text-xs.neutral700--text(v-if="method.sms") {{ method.sms.auto_send_delay_time_value }} {{ method.sms.auto_send_delay_time_unit }} after registration
                div.text-xs.neutral500--text(v-else) Not set

            v-col.shrink
              div
                y-switch.mb-n3(v-model="methodSwitch.sms" :disabled="!method.sms" @change="changeActivationMethod('sms', methodSwitch.sms)")

          v-card.round-xl.pa-6.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
            v-row(dense align="center")
              v-col.grow
                div.d-flex.align-center
                  v-avatar.mr-2(size="8" :color="method.sms ? 'success500' : 'blue500'")
                  div.text-sm.font-medium.neutral700--text Offer message
              v-col(align="right" cols="5")
                y-button(label="View & edit" size="sm" outlined @click="showOfferDeliveranceDialog = true")
                y-button.ml-3(v-if="method.sms" label="Send test message" size="sm" @click="openTestDialog('sms')")

        //- whatsapp
        v-card.round-xl.content-box.pa-6.mt-4(outlined)
          v-row(align="center")
            v-col(cols="2")
              div.d-flex.align-center
                v-icon.mr-3(size="20" color="neutral500") mdi-whatsapp
                div.text-md.font-semibold.neutral700--text WhatsApp
            v-col
              div
                div.text-xs.font-semibold.neutral700--text Offer will be sent:
                div.text-xs.neutral700--text(v-if="method.whatsapp") {{ method.whatsapp.auto_send_delay_time_value }} {{ method.whatsapp.auto_send_delay_time_unit }} after registration
                div.text-xs.neutral500--text(v-else) Not set

            v-col.shrink
              div
                y-switch.mb-n3(v-model="methodSwitch.whatsapp" :disabled="!method.whatsapp" @change="changeActivationMethod('whatsapp', methodSwitch.whatsapp)")

          v-card.round-xl.pa-6.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
            v-row(dense align="center")
              v-col.grow
                div.d-flex.align-center
                  v-avatar.mr-2(size="8" :color="method.whatsapp ? 'success500' : 'blue500'")
                  div.text-sm.font-medium.neutral700--text Offer message
              v-col(align="right" cols="5")
                y-button(label="View & edit" size="sm" outlined @click="showOfferDeliveranceDialog = true")
                y-button.ml-3(v-if="method.whatsapp" label="Send test message" size="sm" @click="openTestDialog('whatsapp')")

        //- email
        v-card.round-xl.content-box.pa-6.mt-4(outlined)
          v-row(align="center")
            v-col(cols="2")
              div.d-flex.align-center
                v-icon.mr-3(size="20" color="neutral500") $yzi-mail-01
                div.text-md.font-semibold.neutral700--text Email
            v-col
              div
                div.text-xs.font-semibold.neutral700--text Offer will be sent:
                div.text-xs.neutral700--text(v-if="method.email") {{ method.email.auto_send_delay_time_value }} {{ method.email.auto_send_delay_time_unit }} after registration
                div.text-xs.neutral500--text(v-else) Not set

            v-col.shrink
              div
                y-switch.mb-n3(v-model="methodSwitch.email" :disabled="!method.email" @change="changeActivationMethod('email', methodSwitch.email)")

          v-card.round-xl.pa-6.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
            v-row(dense align="center")
              v-col.grow
                div.d-flex.align-center
                  v-avatar.mr-2(size="8" :color="method.email ? 'success500' : 'blue500'")
                  div.text-sm.font-medium.neutral700--text Offer email
                div.text-sm.neutral700--text.mt-2(v-if="method.email && method.email.subject") {{ method.email.subject }}
              v-col(align="right" cols="5")
                y-button(label="View & edit" size="sm" outlined @click="showOfferDeliveranceDialog = true")
                y-button.ml-3(v-if="method.whatsapp" label="Send test email" size="sm" @click="openTestDialog('email')")

  .dialogs
    review-offer-deliverance-dialog(v-if="showOfferDeliveranceDialog" :open.sync="showOfferDeliveranceDialog" :offer-data="offer" @updated="fetchOfferDeliverance")
    send-test-sms-dialog(v-if="openTestSmsDialog" :open.sync="openTestSmsDialog" :blast-data="selectedData" @closed="closed")
    send-test-email-dialog(v-if="openTestEmailDialog" :open.sync="openTestEmailDialog" :blast-data="selectedData" @closed="closed")
    send-test-whatsapp-dialog(v-if="openTestWhatsappDialog" :open.sync="openTestWhatsappDialog" :blast-data="selectedData" @closed="closed")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import ReviewOfferDeliveranceDialog from '@/components/review/dialogs/ReviewOfferDeliveranceDialog.vue'
import SendTestSmsDialog from '@/components/clinic/marketing/dialogs/SendTestSmsDialog.vue'
import SendTestEmailDialog from '@/components/clinic/marketing/dialogs/SendTestEmailDialog.vue'
import SendTestWhatsappDialog from '@/components/clinic/marketing/dialogs/SendTestWhatsappDialog.vue'

export default {
  components: { InventoryServicesSelection, ReviewOfferDeliveranceDialog, SendTestSmsDialog, SendTestEmailDialog, SendTestWhatsappDialog, },
  computed: {
    ...mapGetters({ 
      company: 'getCompany',
    }),
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      showOfferDeliveranceDialog: false,
      openTestSmsDialog: false,
      openTestWhatsappDialog: false,
      openTestEmailDialog: false,
      offerEnabled: false,
      offer: null,
      method: {},
      methodSwitch: {},
      rules: {
        not_empty: [v => v.trim().length || 'This field is required'],
        not_empty_array: [v => !!(v && v.length) || 'This field is required']
      },
    }
  },
  mounted () {
    this.fetchOfferDeliverance()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchOfferDeliverance () {
      this.isFetching = true
      this.$axios.get(`/reviews/${this.company.slug}/google_reviews/offers`)
        .then(resp => {
          this.offer = resp.data
          this.offerEnabled = resp.data.status === 'active'
          this.fetchDeliveranceBlast(resp.data.id)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchDeliveranceBlast (id) {
      this.isFetching = true
      this.$axios.get(`/marketing/${this.company.slug}/offers/${id}/blasts`)
        .then(resp => {
          let blasts = resp.data.results
          if (blasts.find(f => f.method === 'sms')) {
            let data = blasts.find(f => f.method === 'sms')
            this.$set(this.method, 'sms', data)
            this.$set(this.methodSwitch, 'sms', data.enabled)
          }
          if (blasts.find(f => f.method === 'email')) {
            let data = blasts.find(f => f.method === 'email')
            this.$set(this.method, 'email', data)
            this.$set(this.methodSwitch, 'email', data.enabled)
          }
          if (blasts.find(f => f.method === 'whatsapp')) {
            let data = blasts.find(f => f.method === 'whatsapp')
            this.$set(this.method, 'whatsapp', data)
            this.$set(this.methodSwitch, 'whatsapp', data.enabled)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    openTestDialog (type) {
      if (type === 'sms') {
        if (this.method.sms) {
          this.selectedData = this.method.sms
        }
        this.openTestSmsDialog = true
      } else if (type === 'email') {
        if (this.method.email) {
          this.selectedData = this.method.email
        }
        this.openTestEmailDialog = true
      } else if (type === 'whatsapp') {
        if (this.method.whatsapp) {
          this.selectedData = this.method.whatsapp
        }
        this.openTestWhatsappDialog = true
      }
    },
    statusChanged (enabled) {
      this.$axios.post(`/reviews/${this.company.slug}/google_reviews/offers`, { name: this.offer.name, status: enabled ? 'active' : 'draft' })
        .then(resp => {
          this.offer = resp.data
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
    },
    changeActivationMethod (method, enabled) {
      let id = this.method[method]?.id
      if (id) {
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${id}`, { enabled })
          .then(() => {
            this.showMessage(['success', this.$t('success_message.successfully_updated')])
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
      }
    },
    closed () {
      this.selectedData = null
    },
  },
}
</script>

<style scoped>

</style>